export const professions = [
    {
        display: 'userAMLQuestionnaire.secondStep.architecture_engineering',
        value: 'architecture_engineering',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.arts_culture_entertainment',
        value: 'arts_culture_entertainment',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.business_management_administration',
        value: 'business_management_administration',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.communications',
        value: 'communications',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.community_social_services',
        value: 'community_social_services',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.education',
        value: 'education',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.science_technology',
        value: 'science_technology',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.installation_repair_maintenance',
        value: 'installation_repair_maintenance',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.farming_fishing_forestry',
        value: 'farming_fishing_forestry',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.elected_government_official',
        value: 'elected_government_official',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.health_medicine',
        value: 'health_medicine',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.law_public_policy',
        value: 'law_public_policy',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.marketing_sales',
        value: 'marketing_sales',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.trading',
        value: 'trading',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.blockchain_applications',
        value: 'blockchain_applications',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.business_owner',
        value: 'business_owner',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.retired',
        value: 'retired',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.student',
        value: 'student',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.unemployed',
        value: 'unemployed',
    },
    {
        display: 'userAMLQuestionnaire.secondStep.other',
        value: 'other',
    },
];